var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.awsNotification)?_c('div',{staticClass:"aws-compliance"},[_vm._v("\n  "+_vm._s(_vm.awsNotification.message)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }